import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, WritableSignal, signal } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
	providedIn: 'root',
})
export class UtilService {
	isSmall: WritableSignal<boolean> = signal(false);

	constructor(
		private iconRegistry: MatIconRegistry,
		private sanitizer: DomSanitizer,
		private snackBar: MatSnackBar,
		private breakpointObserver: BreakpointObserver
	) {}

	scrollIntoView(element: HTMLElement): void {
		element.scrollIntoView({ behavior: 'smooth', block: 'center' });
	}

	registerSlashIcon(): void {
		this.registerIcon('slash', 'assets/slash.svg');
	}

	private registerIcon(name: string, asset: string): void {
		this.iconRegistry.addSvgIcon(
			name,
			this.sanitizer.bypassSecurityTrustResourceUrl(asset)
		);
	}

	errorMessage(message: string): void {
		this.snackBarTimedMessage(message, true);
	}

	snackBarTimedMessage(message: string, error: boolean = false): void {
		this.openSnackBar(message, error);
	}

	private openSnackBar(message: string, error: boolean): void {
		const borderClass: string = error
			? 'error-snackbar-border'
			: 'message-snackbar-border';
		this.snackBar.open(message, null, {
			duration: 5000,
			panelClass: ['timed-snackbar', borderClass],
			verticalPosition: 'top',
		});
	}

	startObservingSize(): void {
		const maxWidthSmall: string = '(max-width: 959.98px)';
		this.breakpointObserver.observe(maxWidthSmall).subscribe((result) => {
			this.isSmall.update(() => result.matches);
		});
	}
}
